export type consentType =
	| 'consentUserActionComplete'
	| 'allConsentGiven'
	| 'adsConsentGiven'
	| 'gaReady'
	| 'noConsentGiven'

type consentParams = {
	type: consentType
	data?: any
}

declare global {
	interface Window {
		pmdConsent: {
			queue: consentParams[]
			(data: consentParams): void
		}
	}
}

/**
 * Check PMD consent queue
 * @param type Consent type
 * @param callback Callback function
 */
export default function consentCheck(type: consentType, callback: () => void): void {
	let timer: number
	const checkConsent = () => {
		if (window?.pmdConsent?.queue?.find((item) => item.type === type)) {
			clearTimeout(timer)
			callback instanceof Function && callback()
		} else if (window?.pmdConsent?.queue?.find((item) => item.type === 'noConsentGiven')) {
			clearTimeout(timer)
		} else {
			timer = window.setTimeout(() => {
				requestAnimationFrame(checkConsent)
			}, 100)
		}
	}
	window.requestAnimationFrame(checkConsent)
}
